<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div
          class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100"
        >
          <a
            class="nav-link"
            @click="tab = 'all'"
            href="javascript:void(0)"
            :class="{ active: tab === 'all' }"
          >
            {{ $t('all_results') }}
            <span
              class="count ml-1"
              v-if="results.distributions.length || results.artists.length || results.labels.length"
            >({{ results.distributions.length + results.artists.length + results.labels.length }})</span>
          </a>
          <a
            class="nav-link"
            @click="tab = 'distributions'"
            href="javascript:void(0)"
            :class="{ active: tab === 'distributions' }"
          >
            {{ $t('section_distribution') }}
            <span
              class="count ml-1"
              v-if="results.distributions.length"
            >({{ results.distributions.length }})</span>
          </a>
          <a
            class="nav-link"
            @click="tab = 'artists'"
            href="javascript:void(0)"
            :class="{ active: tab === 'artists' }"
          >
            {{ $t('artists') }}
            <span
              class="count ml-1"
              v-if="results.artists.length"
            >({{ results.artists.length }})</span>
          </a>
          <a
            class="nav-link"
            @click="tab = 'labels'"
            href="javascript:void(0)"
            :class="{ active: tab === 'labels' }"
          >
            {{ $t('labels') }}
            <span
              class="count ml-1"
              v-if="results.labels.length"
            >({{ results.labels.length }})</span>
          </a>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
      </div>

      <h4
        class="page-title"
        v-show="tab === 'all' || tab === 'distributions'"
        v-if="!loading && results.distributions.length"
      >{{ $t('section_distribution') }}</h4>
      <div
        v-show="tab === 'all' || tab === 'distributions'"
        class="row row-projects"
        v-if="!loading && results.distributions.length"
      >
        <div class="col-sm-6 col-lg-3" v-for="item in results.distributions" v-bind:key="item._id">
          <div class="card">
            <div class="p-2">
              <router-link :to="`/distributions/${item._id}`">
                <img
                  class="card-img-top rounded"
                  :src="item.cover_image_small || item.cover_image || defaultImage"
                  :alt="item.name"
                  onerror="this.src = '/static/img/img-placeholder.jpg'"
                />
              </router-link>
            </div>
            <div class="card-body pt-2">
              <router-link :to="`/distributions/${item._id}`">
                <h4 class="mb-1 fw-bold">{{ item.title }}</h4>
              </router-link>
              <p class="text-muted small mb-0">{{ item.main_genre }}</p>
            </div>
          </div>
        </div>
      </div>

      <h4
        class="page-title"
        v-show="tab === 'all' || tab === 'artists'"
        v-if="!loading && results.artists.length"
      >Artists</h4>
      <div
        v-show="tab === 'all' || tab === 'artists'"
        class="row row-projects"
        v-if="!loading && results.artists"
      >
        <div class="col-sm-6 col-lg-3" v-for="item in results.artists" v-bind:key="item._id">
          <div class="card">
            <div class="p-2">
              <router-link :to="`/artists/${item.key}`">
                <img
                  class="card-img-top rounded"
                  :src="item.cover_image_small || item.cover_image || defaultImage"
                  :alt="item.name"
                  onerror="this.src = '/static/img/img-placeholder.jpg'"
                />
              </router-link>
            </div>
            <div class="card-body pt-2">
              <router-link :to="`/artists/${item.key}`">
                <h4 class="mb-1 fw-bold">{{ item.name }}</h4>
              </router-link>
              <p class="text-muted small mb-0">{{ item.main_genre }}</p>
            </div>
          </div>
        </div>
      </div>

      <h4
        class="page-title"
        v-show="tab === 'all' || tab === 'labels'"
        v-if="!loading && results.labels.length"
      >Labels</h4>
      <div
        v-show="tab === 'all' || tab === 'labels'"
        class="row row-projects"
        v-if="!loading && results.labels"
      >
        <div class="col-sm-6 col-lg-3" v-for="item in results.labels" v-bind:key="item._id">
          <div class="card">
            <div class="p-2">
              <router-link :to="`/labels/${item._id}`">
                <img
                  class="card-img-top rounded"
                  :src="item.cover_image_small || item.cover_image || defaultImage"
                  :alt="item.name"
                  onerror="this.src = '/static/img/img-placeholder.jpg'"
                />
              </router-link>
            </div>
            <div class="card-body pt-2">
              <router-link :to="`/labels/${item._id}`">
                <h4 class="mb-1 fw-bold">{{ item.name }}</h4>
              </router-link>
              <p class="text-muted small mb-0">{{ item.main_genre }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Search from '../services/search'

export default {
  name: 'GlobalSearch',
  data: function () {
    return {
      defaultImage: '/static/img/img-placeholder.jpg',
      loading: true,
      tab: 'all',
      results: {
        distributions: [],
        artists: [],
        labels: []
      }
    }
  },
  watch: {
    $route: function (to, from) {
      this.search()
    }
  },
  methods: {
    search: function () {
      Search.getAll({ query: this.$route.query.q }).then(response => {
        this.loading = false
        this.results = response.data
        this.$eventBus.$emit('endSearch')
      })
    }
  },
  created: function () {
    this.search()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GlobalSearch.vue